const request = require('request');
const config = require('./config');

var post = (token,filters) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/permissaoFuncionalidade/'+filters.permissao_id_md5+"/"+filters.funcionalidade_id_md5,
      method: 'POST',
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

var remove = (token,filters) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/permissaoFuncionalidade/'+filters.permissao_id_md5+"/"+filters.funcionalidade_id_md5,
      method: 'DELETE',
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

var getPermissoes = (token) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/permissaoFuncionalidade/checkPermission',
      method: 'GET',
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

module.exports = {
  post:post,
  remove:remove,
  getPermissoes:getPermissoes
}